import React from 'react';
import { labelByKey } from '@cm/new-shared-fe/services/labels';

export const LoginMyCm = (props) => {
  const { loginUrl = '#' } = props;

  return (
    <div className="relative rounded-cm-default bg-beige-light py-4 px-6 my-2">
      <h2 className="font-header text-xl leading-normal">{labelByKey('login_card.title')}</h2>
      <hr className="hr-green"/>
      <p className="text-md mb-3">{labelByKey('login_card.message')}</p>
      <a
        href={loginUrl}
        className="button text-white bg-green hover:bg-green-dark hover:text-white hover:no-underline md:w-full"
      >
        <span>{labelByKey('login_card.button.label')}</span>
      </a>
    </div>
  );
};
